import { grantPredicate } from "@p0security/shared/assessment/dsl";
import { grantReducers } from "@p0security/shared/assessment/reducers/grant";

import { grantColumns } from "./columns";

export const grantData = {
  predicate: grantPredicate,
  reducers: grantReducers,
  columns: grantColumns,
};
